import { ErrataNotaComplementarJustificativaEnum } from 'graphql/types.generated'

import {
  justificativasPorTipoErrataNotaComplementarRecord,
  TipoErrataNotaComplementarEnum,
} from './model-errataNotaComplementar'

export const getTipoErrataNotaComplementarByJustificativa = (
  justificativa: ErrataNotaComplementarJustificativaEnum
): TipoErrataNotaComplementarEnum => {
  const isErrata = justificativasPorTipoErrataNotaComplementarRecord[TipoErrataNotaComplementarEnum.ERRATA].includes(
    justificativa
  )

  return isErrata ? TipoErrataNotaComplementarEnum.ERRATA : TipoErrataNotaComplementarEnum.NOTA_COMPLEMENTAR
}
